<script>
import * as m from '@app/paraglide/messages.js';
import { onMount } from 'svelte';
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    markerState
} from '@app/store/markerStore.svelte.js';
import _Marker from "@cclib/classes/marker.js";
import {
    fade
} from 'svelte/transition';
import Swal from 'sweetalert2';
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";

import tcLib from "@cclib/lib/timecode.js";
import { detectSceneChanges } from "@app/lib/detectSceneChanges.js";

let progress = $state(0),
    statusMsg = $state(m.scene_change_detection_starting_status()),
    duration = 10,
    durationTc = "00:00:10:00";

function updateProgress(tc) {
    let tcSec = tcLib.tcMsToSec(tc);
    progress = ((tcSec.toFixed(2)/duration) * 100).toFixed(2);
    console.log(tcSec, progress);
}

onMount(() => {
    markerState.lists[0].markers = [];
    try {
        toast.push(m.scene_change_detection_scanning_toast(), {classes: ['toast-info']});

        //Ask customer using swal alert if they want scene change detection low, medium, or high
        Swal.fire({
            ...SWAL_BASE,
            customClass: {
                ...SWAL_CLASSES.trial,
                denyButton: "btn btn-warning mx-2",
                cancelButton: SWAL_CLASSES.destructive.confirmButton,
            },
            title: m.scene_change_detection_alert_title(),
            text: m.scene_change_detection_alert_text(),
            icon: 'question',
            //disallow outside click
            allowOutsideClick: false,
            //disallow escape key
            allowEscapeKey: false,
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: m.scene_change_detection_low_button(),
            denyButtonText: m.scene_change_detection_medium_button(),
            cancelButtonText: m.scene_change_detection_high_button(),
        }).then(async (result) => {
            // High = most sensitive, Low = least (maps to post-process presets)
            let sensitivity;
            if (result.isDismissed) {
                sensitivity = "high";
            } else if (result.isDenied) {
                sensitivity = "medium";
            } else if (result.isConfirmed) {
                sensitivity = "low";
            } else {
                hideModal();
                return;
            }

            console.log(sensitivity, projectState.media.localPath);

            try {
                const shots = await detectSceneChanges({
                    inputPath: projectState.media.localPath,
                    sensitivity,
                    onStart(commandLine) {
                        console.log('Spawned Ffmpeg with command: ' + commandLine);
                    },
                    onCodecData(data) {
                        durationTc = data.duration;
                        duration = tcLib.tcMsToSec(data.duration);
                        console.log('Input is ' + data.audio + ' audio ' +
                            'with ' + data.video + ' video');
                    },
                    onProgress(prog) {
                        updateProgress(prog.timemark);
                        statusMsg = m.scene_change_detection_progress_status({
                            timemark: prog.timemark,
                            duration: durationTc,
                            progress: progress
                        });
                        console.log('Scanning: ' + prog.timemark + ' done', prog);
                    },
                });

                markerState.lists[0].markers = shots.map((shot, index) => ({
                    ...(new _Marker({
                        time: shot.time,
                        comment: m.scene_change_detection_marker_comment({ number: index + 1 })
                    }))
                }));

                toast.push(m.scene_change_detection_complete_toast(), {classes: ['toast-success']});
                console.log('Finished Scanning', shots.length);
                hideModal();
            } catch (err) {
                console.log(err);
                toast.push(m.scene_change_detection_failed_toast({error: err.message}), {classes: ['toast-warning']});
                console.log('Cannot scan video: ' + err.message);
                statusMsg = m.scene_change_detection_cannot_scan_status({error: err.message});
                progress = 100;
                hideModal();
            }
        });

    } catch (err) {
        console.log(err, err.message);
        toast.push(m.scene_change_detection_failed_toast({error: err.message}), {classes: ['toast-warning']});
    }
});
</script>

<div transition:fade={{duration: 100}} class="modal {modalState.selected === 'sceneChangeDetection' ? 'show d-block' : ''}" role="dialog" aria-labelledby="sceneChangeTitle" tabindex="-1" id="SceneChangeDetectionModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="sceneChangeTitle">{m.scene_change_detection_title()}</h4>
            </div>
            <div class="modal-body">
                <p><i class="bi bi-exclamation-diamond-fill" role="img" aria-hidden="true"></i> {m.scene_change_detection_detecting_text()}</p>
                <div class="progress" role="progressbar" aria-label={m.scene_change_detection_progress_aria_label()} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar bg-primary progress-bar-striped progress-bar-animated" style="width: {progress}%;">{progress}%</div>
                </div>
                <p class="text-center text-muted small" aria-live="polite">{statusMsg}</p>
            </div>
        </div>
    </div>
</div>
